import React, { memo } from 'react';
import { Typography } from '@mui/material';

const ExplanationSubTitle = ({ children }) => {
  return (
    <Typography variant={'h6'} component={'h3'} gutterBottom>{children}</Typography>
  );
};

export default memo(ExplanationSubTitle);
